import { Typography } from "@mui/material";
import I18n from "i18n-js";

export interface CopyRightProps {
  full?: boolean;
}
export default function CopyRight({ full = true }: CopyRightProps) {
  return (
    <Typography variant="body2" fontSize={10} sx={{ textAlign: "center" }}>
      {full
        ? `Copyright © ${new Date().getFullYear()} ${I18n.t("App.title")}`
        : `© ${new Date().getFullYear()}`}
    </Typography>
  );
}
